import ApiService from '../../../../shared/services/api-service';
import commonActionCreators from '../../../../shared/store/common/action-creators';
import trainingPhasesActionsCreators from './training-phases';
import oitsActionCreators from '../../oits/action-creators/index';

const trainingPhasesRemedialsActions = {
  completeRemedial(formData) {
    const postData = { completedAt: formData.completedAt };
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('completeRemedial'));
      const data = await ApiService.post(
        `/api/v1/remedials/${formData.remedialGuid}/complete`,
        postData,
      )
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(trainingPhasesActionsCreators.setIsLoading('completeRemedial'));
      if (data.error) {
        dispatch(commonActionCreators.handleApiError(data.error));
      } else {
        dispatch(this.completeRemedialSuccess(data));
      }
    };
  },
  completeRemedialSuccess(completed) {
    return (dispatch) => {
      dispatch(oitsActionCreators.fetchTrainingPhase(completed.data.attributes.trainingPhase.trainingPhaseGuid));
    };
  },
};

export default trainingPhasesRemedialsActions;
